import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateTenantClass } from '@services/registry';

export function useUpdateTenantClass({ tenantId }) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ classId, payload }) => {
            return await updateTenantClass({ tenantId, classId, payload });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['tenantClasses', tenantId] });
        },
    });
}

